import { determineErrorFromResponse } from 'helpers/ContentHelper';
import { FETCH_DETAIL_CATEGORY, CLEAR_DETAIL_CATEGORY } from './PersonalityActions';
import { getDetailData } from './PersonalityHelper';

const INITIAL_STATE = {
  bio: null,
  seo: null,
  faq: [],
  seriesData: null,
  socials: null,
  collections: null,
  favoritableItems: [],
};

export default function(state = INITIAL_STATE, action) {
  const errors = determineErrorFromResponse(action);
  switch (action.type) {
    case FETCH_DETAIL_CATEGORY: {
      const data = action?.payload?.data ?? null;
      const panels = data?.panels?.member ?? null;
      if (errors) return { ...state, errors };
      if (!data || !panels) return state;
      const { favoritableItems, seo, faq, bio, socials, collections } = getDetailData({ data });
      return {
        ...state,
        bio,
        collections,
        faq,
        favoritableItems,
        seo,
        seriesData: data,
        socials,
      };
    }
    case CLEAR_DETAIL_CATEGORY: {
      return INITIAL_STATE;
    }
    default:
      return state;
  }
}
